/**
 * タブUI（Vanilla JS） ver1.0.0
 * ES6
 *
 * □機能
 * ・WAI-AREAに対応
 * ・セレクトボックスでの切り替えに対応（タブが多めの時にスマホで便利）
 * ・タブでの切り替え（当たり前）
 *
 * □使い方
 * data-tabui="select" は 必要であれば
 * button は aタグ でも可（その場合 data-tabui-href は href に変更 type="button" は削除）
 *
 <div data-tabui="root">
   <select data-tabui="select">
     <option label="タブ A" value="#a">タブ A</option>
     <option label="タブ B" value="#b">タブ B</option>
     <option label="タブ C" value="#c">タブ C</option>
     <option label="タブ D" value="#d">タブ D</option>
   </select>

   <ul data-tabui="tablist" aria-label="タブ">
     <li role="none presentation">
       <button data-tabui="tab" data-tabui-href="#a" id="tab-a" type="button">タブ A</button>
     </li>
     <li role="none presentation">
       <button data-tabui="tab" data-tabui-href="#b" id="tab-b" type="button" class="is-active">タブ B</button>
     </li>
     <li role="none presentation">
       <button data-tabui="tab" data-tabui-href="#c" id="tab-c" type="button">タブ C</button>
     </li>
     <li role="none presentation">
       <button data-tabui="tab" data-tabui-href="#d" id="tab-d" type="button">タブ D</button>
     </li>
   </ul>

   <div data-tabui="contents">
     <div data-tabui="tabpanel" id="a">
       <div>
         <p>
           吾輩は猫である。名前はまだ無い。どこで生れたかとんと見当がつかぬ。何でも薄暗いじめじめした所でニャーニャー泣いていた事だけは記憶している。吾輩はここで始めて人間というものを見た。しかもあとで聞くとそれは書生という人間中で一番獰悪な種族であったそうだ。この書生というのは時々我々を捕えて煮て食うという話である。しかしその当時は何という考もなかったから別段恐しいとも思わなかった。ただ彼の掌に載せられてスーと持ち上げられた時何だかフワフワした感じがあったばかりである。掌の上で少し落ちついて書生の顔を見たのがいわゆる人間というものの見始であろう。この時妙なものだと思った感じが今でも残っている。第一毛をもって装飾されべきはずの顔がつるつるしてまるで薬缶だ。その後猫にもだいぶ逢ったがこんな片輪には一度も出会わした事がない。のみならず顔の真中があまりに突起している。そうしてその穴の中から時々ぷうぷうと煙を
         </p>
       </div>
     </div>
     <div data-tabui="tabpanel" id="b">タブパネル B</div>
     <div data-tabui="tabpanel" id="c">タブパネル C</div>
     <div data-tabui="tabpanel" id="d">タブパネル D</div>
   </div>
 </div>
 */
export default (APP) => {
  /* タブの親 */
  const $tabRoots = document.querySelectorAll('[data-tabui="root"]')

  /* タブの親の数 */
  const tabRootsLength = $tabRoots.length

  /**
   * 初期動作
   * ・状態のリセット...etc
   * ・イベント設定
   */
  function init () {
    for (let i = 0; i < tabRootsLength; i++) {
      const $tabRoot = $tabRoots[i]
      const $tabList = $tabRoot.querySelector('[data-tabui="tablist"]')
      const $select = $tabRoot.querySelector('[data-tabui="select"]')
      const $tabs = $tabRoot.querySelectorAll('[data-tabui="tab"]')
      let selectedValue = null

      $tabList.setAttribute('role', 'tablist')

      const tabsLength = $tabs.length

      for (let j = 0; j < tabsLength; j++) {
        const $tab = $tabs[j]
        const $tabPanel = getTabPanel($tab)

        const tabId = $tab.getAttribute('id')
        const tabPanelId = $tabPanel.getAttribute('id')
        const selected = ($tab.getAttribute('area-selected') === 'true') || ($tab.classList.contains('is-active'))

        $tab.setAttribute('aria-controls', tabId)
        $tabPanel.setAttribute('aria-labelledby', tabPanelId)

        $tab.setAttribute('role', 'tab')
        $tabPanel.setAttribute('role', 'tabpanel')

        $tabPanel.setAttribute('tabindex', 0)
        $tabPanel.setAttribute('aria-hidden', 'true')

        $tab.addEventListener('click', onClickTab, false)

        if (selected) {
          selectedValue = getTabPanelSelector($tab)

          changeStateShow($tab, $tabPanel)
        } else {
          changeStateHide($tab, $tabPanel)
        }
      }

      /* セレクトボックスがある場合の初期動作 */
      if ($select) {
        if (selectedValue) $select.value = selectedValue
        $select.addEventListener('change', onChangeTab, false)
      }
    }
  }

  /**
   * 状態の切り替え：show
   */
  function changeStateShow ($tab, $tabPanel, display) {
    $tab.setAttribute('aria-selected', 'true')
    $tab.removeAttribute('tabindex')
    $tab.classList.add('is-active')
    $tabPanel.setAttribute('aria-hidden', 'false')

    if (!display && display !== false) $tabPanel.style.display = 'inherit'
  }

  /**
   * 状態の切り替え：hide
   */
  function changeStateHide ($tab, $tabPanel, display) {
    $tab.setAttribute('aria-selected', 'false')
    $tab.setAttribute('tabindex', '-1')
    $tab.classList.remove('is-active')
    $tabPanel.setAttribute('aria-hidden', 'true')

    if (!display && display !== false) $tabPanel.style.display = 'none'
  }

  /**
   * クリックイベント
   */
  function onClickTab (event) {
    event.preventDefault()

    const $selectedTab = event.currentTarget
    const selected = ($selectedTab.getAttribute('area-selected') === 'true') || ($selectedTab.classList.contains('is-active'))

    if (selected) return

    const $tabRoot = APP.ex.closest($selectedTab, '[data-tabui="root"]')
    const $selectedTabPanel = getTabPanel($selectedTab)
    const $deselectedTabs = $tabRoot.querySelectorAll('[data-tabui="tab"]')
    const deselectedTabsLength = $deselectedTabs.length

    for (let i = 0; i < deselectedTabsLength; i++) {
      const $deselectedTab = $deselectedTabs[i]
      const $deselectedTabPanel = getTabPanel($deselectedTab)

      changeStateHide($deselectedTab, $deselectedTabPanel)
    }

    changeStateShow($selectedTab, $selectedTabPanel)

    if ($tabRoot.querySelector('[data-tabui="select"]')) {
      const $select = $tabRoot.querySelector('[data-tabui="select"]')
      $select.value = getTabPanelSelector($selectedTab)
    }
  }

  function onChangeTab (event) {
    const $selectedSelect = event.currentTarget
    const href = $selectedSelect.value

    const $tabRoot = APP.ex.closest($selectedSelect, '[data-tabui="root"]')
    const $selectedTab = $tabRoot.querySelector('[data-tabui-href="' + href + '"], [href="' + href + '"]')
    const $selectedTabPanel = getTabPanel($selectedTab)
    const $deselectedTabs = $tabRoot.querySelectorAll('[data-tabui="tab"]')
    const deselectedTabsLength = $deselectedTabs.length

    for (let i = 0; i < deselectedTabsLength; i++) {
      const $deselectedTab = $deselectedTabs[i]
      const $deselectedTabPanel = getTabPanel($deselectedTab)

      changeStateHide($deselectedTab, $deselectedTabPanel)
    }

    changeStateShow($selectedTab, $selectedTabPanel)
  }

  /**
   * タブに対応するタブパネルを取得
   */
  function getTabPanelSelector ($tab) {
    let selector = $tab.getAttribute('data-tabui-href')

    if (!selector) selector = $tab.getAttribute('href')
    if (!selector) selector = $tab.value

    return selector
  }

  function getTabPanel ($tab) {
    return document.querySelector(getTabPanelSelector($tab))
  }

  /**
   * -- 親から継承する
   * .closest()のように直近の親要素を取得する
   * 参考元：https://spyweb.media/2018/01/03/jquery-closest-pure-javascript/
  function closest(node, selector) {
    // IEや一部ブラウザでは.closet()が実装されていないので自前も用意
    return (node.closest || function(_selector) {
      do {
        // nodeとselectorがマッチしたら返す
        if ((node.matches || node.msMatchesSelector).call(node, _selector)) {
          return node;
        }
        // マッチしなかったら親要素を代入
        node = node.parentElement || node.parentNode;
      } while (node !== null && node.nodeType === 1)

      return null;
    }).call(node, selector)
  }
  */

  if ($tabRoots) {
    init()
  }
}
